<script setup lang="ts">
  import { TravelDirection } from '@/shared/types/common.types'
  import { FlowTravelDatesWidgetQC } from '@/widgets/Flow'
</script>

<template>
  <FlowTravelDatesWidgetQC :type-of-travel="TravelDirection.INBOUND" />
</template>
